<template>
  <div class="store_list nodrag">
    <div class="base">
      <div class="list_thumb" @click="goShopDetail(store)">
        <div class="n_thumb">
          <div class="n_thumb_inner">
            <img :src="store.storePhoto" alt="" />
          </div>
        </div>
      </div>
      <div class="store_info" @click="goShopDetail(store)">
        <div class="bookmark" v-if="store.followed">
          <input
            type="checkbox"
            :checked="store.followed"
            v-model="store.followed"
            disabled
            id="book"
          />
          <label for="book"></label>
        </div>
        <div class="ttl_wrap">
          <div class="ttl">
            <h1>
              {{ store.name }}
              <span v-if="store.cert === 1">
                <img src="@/assets/front/images/new/icon_consent_s.png" />
              </span>
            </h1>
          </div>
          <p>{{ store.address }} {{ store.addressDetail }}</p>
        </div>
        <div class="shop_index_wrap">
          <div class="shop_index">
            <dl>
              <dd>
                <div
                  class="score"
                  :data-score="Math.floor(store.evaluationScore)"
                >
                  <ul>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                    <li></li>
                  </ul>
                </div>
              </dd>
              <dd class="review">{{ calcScore }}점({{ store.reviewCnt }}건)</dd>
            </dl>
          </div>
          <div class="shop_index">
            <dl>
              <dt>응답률</dt>
              <dd v-if="store.chatCnt > 0 && store.responseRate > 0">
                {{ store.responseRate > 100 ? 100 : store.responseRate }}%
              </dd>
              <dd v-else style="padding:0 0.5rem">-</dd>
              <dd
                v-if="
                  store.responseMinute >= 0 &&
                    store.responseMinute <= 10 &&
                    store.chatCnt > 0 &&
                    store.responseRate > 0
                "
                style="margin-left:0.2rem"
              >
                (10분 이내)
              </dd>
              <dd
                v-if="
                  store.responseMinute > 10 &&
                    store.responseMinute <= 30 &&
                    store.chatCnt > 0
                "
                style="margin-left:0.2rem"
              >
                (30분 이내)
              </dd>
              <dd
                v-if="
                  store.responseMinute > 30 &&
                    store.responseMinute <= 60 &&
                    store.chatCnt > 0 &&
                    store.responseRate > 0
                "
                style="margin-left:0.2rem"
              >
                (1시간 이내)
              </dd>
              <dd
                v-if="
                  store.responseMinute > 60 &&
                    store.responseMinute <= 120 &&
                    store.chatCnt > 0 &&
                    store.responseRate > 0
                "
                style="margin-left:0.2rem"
              >
                (2시간 이내)
              </dd>
              <dd
                v-if="
                  store.responseMinute > 120 &&
                    store.responseMinute <= 360 &&
                    store.chatCnt > 0 &&
                    store.responseRate > 0
                "
                style="margin-left:0.2rem"
              >
                (6시간 이내)
              </dd>
              <dd
                v-if="
                  store.responseMinute > 360 &&
                    store.chatCnt > 0 &&
                    store.responseRate > 0
                "
                style="margin-left:0.2rem"
              >
                (6시간 이상)
              </dd>
              <dt class="chat_cnt">상담</dt>
              <dd>{{ store.chatCnt }}건</dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <p class="add_info_01" v-if="store.info">
      {{ store.info }}
    </p>
    <!-- <div class="add_info_02">
      <ul>
        <li><p># 사전승낙점</p></li>
        <li><p># SKT</p></li>
        <li><p># 친절한 집</p></li>
        <li><p># 알뜰폰</p></li>
      </ul>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    store: Object,
  },
  computed: {
    calcScore() {
      return Math.round(this.store.evaluationScore * 10) / 10;
    },
  },
  methods: {
    goShopDetail(shop) {
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: shop.id,
        },
      });
      // this.$emit('goShopDetail', shop.id);
    },
    toggle(id) {
      this.$emit('toggle', id);
    },
  },
};
</script>
